export default __webpack_public_path__ + "static/SectionTwo_02_04@2x-706314b5dc7bf23577ba76401b779bf7.png";